import ibox from "webutils/ibox/ibox";
import scss from 'webutils/ibox/ibox.scss'
import iboxToolbar from "webutils/ibox/ibox.toolbar";

//dependencies
import touch from "angular-touch";
import animate from "angular-animate";
import collapse from "angular-ui-bootstrap/src/collapse";

//styles

export const dependencies = [collapse, touch, animate];
export const components = {
  ibox,
  iboxToolbar
};

export default {
  dependencies,
  components
};
